'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _Data = require('./Data.css');

var _Data2 = _interopRequireDefault(_Data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Data = (_dec = (0, _reactCssModules2.default)(_Data2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Data, _Component);

  function Data(props) {
    (0, _classCallCheck3.default)(this, Data);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Data.__proto__ || (0, _getPrototypeOf2.default)(Data)).call(this, props));

    _this.state = {
      title: 'The data',
      description: 'We rate retirement plans and mutual funds on environmental and social sustainability issues.',
      url: _config2.default.domain + _config2.default.routes.data
    };
    return _this;
  }

  (0, _createClass3.default)(Data, [{
    key: 'render',
    value: function render() {
      var iconPlans = require('../../../static/images/icon-plans.png');
      var iconTargetDates = require('../../../static/images/icon-target-dates.png');
      var iconMutualFunds = require('../../../static/images/icon-mutual-funds.png');
      var iconManagers = require('../../../static/images/icon-managers.png');
      var iconCompanies = require('../../../static/images/icon-companies.png');
      var iconMethodology = require('../../../static/images/icon-methodology.png');

      var descriptions = {
        'Retirement plans': 'Most retirement plans are structured as a list of 10-20 investment options. Our sustainability scorecard rates employer-offered 401(k)s and other retirement plans based on their investments in fossil fuels, arms manufacturers, and other environmentally and socially risky companies.',
        'Asset managers': 'Retirement plans are usually based around funds from major asset managers like Vanguard, BlackRock, and Fidelity. We analyze these managers\' funds to measure their investments in sustainability risk sectors.',
        'Target date funds': 'Target date funds are a series of funds, where each fund in the series is marketed at investors with different retirement time horizons. The default option in employer-offered retirement plans is often a target date fund series. We\'ve rated 12 of the largest target date funds on environmentally and social risk issues.',
        'Mutual funds & ETFs': 'We rate mutual funds and ETFs on environmental and social sustainability risks based on what stocks the fund is invested in, including fossil fuels, deforestation, gender equality, civilian firearms, the prison industrial complex, arms manufacturers and military contractors, and tobacco.',
        'Publicly-traded companies': 'Using research from a wide range of issue experts, we track sustainability risks for thousands of global companies across environmental and social issues.',
        'Methodology': 'Detailed methodology on how we track investments, analyze sustainability risk, and assign portfolio ratings.'
      };
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _container2.default.helmet(this.state.title, this.state.description, this.state.url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'h1',
            { styleName: 'title' },
            this.state.title
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'copy' },
            _react2.default.createElement(
              'nav',
              null,
              [[_config2.default.routes.plans, 'Retirement plans', iconPlans], [_config2.default.routes.targetDateFunds, 'Target date funds', iconTargetDates], [_config2.default.routes.mutualFundsETFs, 'Mutual funds & ETFs', iconMutualFunds], [_config2.default.routes.assetManagers, 'Asset managers', iconManagers], [_config2.default.routes.companies, 'Publicly-traded companies', iconCompanies], [_config2.default.routes.methodology, 'Methodology', iconMethodology]].map(function (e, i) {
                var _e = (0, _slicedToArray3.default)(e, 3),
                    url = _e[0],
                    title = _e[1],
                    icon = _e[2];

                var description = descriptions[title] || 'Lorem';
                return _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'button',
                    {
                      styleName: 'data-link',
                      key: 'data-link-' + i
                    },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: url,
                        title: title
                      },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'data-link-in' },
                        _react2.default.createElement('img', {
                          src: icon,
                          alt: title
                        }),
                        _react2.default.createElement(
                          'div',
                          null,
                          _react2.default.createElement(
                            'h2',
                            null,
                            title
                          ),
                          _react2.default.createElement(
                            'p',
                            null,
                            description
                          ),
                          _react2.default.createElement(
                            'p',
                            null,
                            'Learn more',
                            _react2.default.createElement(_components.LinkIcon, null)
                          )
                        )
                      )
                    )
                  ),
                  _react2.default.createElement('hr', null)
                );
              })
            )
          )
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null)
      );
    }
  }]);
  return Data;
}(_react.Component)) || _class);
exports.default = Data;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Data/Data.js
// module id = 1471
// module chunks = 0